import React from "react";
import { Link , useNavigate} from "react-router-dom";

import logo from "../../assets/logo.jpeg";
import home from "../../assets/home-filled.png";
import chat from "../../assets/chat-filled.png";
import profile from "../../assets/profile-filled.png";

function TopBar() {
  
  const navigate = useNavigate();

  return (
    <div className="flex px-5 py-2 w-full shadow text-lg bg-black bg-opacity-10 sticky top-0 z-40 text-center justify-between text-white">
    <div className="h-12 flex items-center gap-2">
      <img
        src={logo}
        alt="magic moments"
        className="h-full w-12 rounded-full"
        onClick={(e)=>{
          e.preventDefault();
          navigate("/creator/")
        }}
      />
      <h4 className="font-semibold my-1">Magic Moments</h4>
    </div>
      <div className="flex items-center gap-2.5 font-semibold">
        <Link to="/creator/">
          <div className="flex items-center gap-1 p-1.5 rounded-md">
            <img src={home} alt="home" className="w-5 h-5" /> Home
          </div>
        </Link>
        <Link to="/creator/chats">
          <div className="flex items-center gap-1 p-1.5 rounded-md">
            <img src={chat} alt="chat" className="w-5 h-5" /> Chat
          </div>
        </Link>
        <Link to="/creator/profile">
          <div className="flex items-center gap-1 p-1.5 rounded-md">
            <img src={profile} alt="profile" className="w-5 h-5" /> Profile
          </div>
        </Link>
      </div>
    </div>
  );
}

export default TopBar;
